import React, { useCallback, useState, FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { useCreateQuickRequestMutation } from './graphql/CreateQuickRequestMutation'

interface ISendRequestButtonProps {
  shipmentStopId?: string
}

export const SendRequestButton: FC<ISendRequestButtonProps> = ({ shipmentStopId = '' }) => {
  const { openToast } = useGlobalToast()
  const [sendRequest] = useCreateQuickRequestMutation()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const sendRequestClickHandler = useCallback(async () => {
    setIsLoading(true)

    try {
      const { errors } = await sendRequest({
        variables: {
          input: {
            shipmentStopId,
          },
        },
      })

      const [error] = errors || []

      if (error) {
        throw error
      }

      openToast({
        toastMessage: 'Request sent',
      })
    } catch (error) {
      openToast({
        toastMessage: error?.message,
        toastType: 'alert',
      })
    } finally {
      setIsLoading(false)
    }
  }, [openToast, sendRequest, shipmentStopId])

  return (
    <Button color='secondary' onClick={sendRequestClickHandler} disabled={isLoading}>
      Send Request
    </Button>
  )
}

export default SendRequestButton
